import React, { Component } from "react";
import "../auth/auth.css";
import "../app/base-style.css";
import { useStyles } from "../app/base-style";
import { authStyles } from "../auth/auth-style";
import { Card, CardContent,Grid } from "@material-ui/core";
import "./quick-pay.css";
import { useMediaQuery } from "react-responsive";
import { QuickPayLanding } from "./quick-pay-landing";
import { adminService } from "../../services/index";
import { Skeleton } from "@material-ui/lab";
import { QuickPayCommonHeader } from "./quick-pay-header";
import {store } from "../../helpers/store"
import { useEffect } from "react";
import { bearerTokenService } from "../../services/bearer.service";

function QuickPay(props) {
  const classes = useStyles();
  const authClasses = authStyles();
  const isTabletOrMobile = useMediaQuery({ query: "(min-width: 960px)" });
  let quinaryBackgroundBlur = `rightSecondaryBack landingHeight ${classes.quinaryBackground}`;
  let primaryBackgroundBlur = `primaryBack ${classes.primaryBackground} `;
  
  useEffect(()=>{
    const rocketContainer = document.querySelector('.rocketchat-container');
    const rocketWidget = document.querySelector('.rocketchat-widget')
    if(rocketContainer && rocketWidget) {
      rocketContainer.style.display = "none"
      rocketWidget.style.display = "none" 
    }
  })

  return (
    <React.Fragment>
      {isTabletOrMobile ? (
        <React.Fragment>
          <Grid container direction="column">
            <Grid item>
              <div className={primaryBackgroundBlur} />
            </Grid>
            <Grid item>
              <div className={quinaryBackgroundBlur} />
            </Grid>
          </Grid>
          <Card className="stack-top">
            <QuickPayMain
              baseStyle={classes}
              authStyle={authClasses}
              propsMain={props}
            />
          </Card>
        </React.Fragment>
      ) : (
        <div className="margin-top-60">
          <QuickPayMain
            baseStyle={classes}
            authStyle={authClasses}
            propsMain={props}
          />
        </div>
      )}
    </React.Fragment>
  );
}
class QuickPayMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
      labelSubTitle: "",
      lastNote: "",
    };
  }

  async componentDidMount() {
    store.getState().snackbar=true;
    if(localStorage.getItem("authbearer")){
     await this.callAdmin();
    }else{
    await bearerTokenService
    .getBearerToken()
    .then(async (successBearer) => {          
      await this.callAdmin();                   
    })
    .catch((error) => {
      
    });
  }
}

async callAdmin(){
  await adminService.getContentData("en", "USER_MANAGEMENT").then((res) => { 
    store.getState().snackbar=false;     
    this.setState({
      data: res.data.getContents.USER_MANAGEMENT,
    });
    res.data.getContents.USER_MANAGEMENT.forEach((item) => {
      if (item.contentCode === "QUICK_PAY_SUBTITLE") {
        this.setState({
          labelSubTitle: item.answer,
        });
      } else if (item.contentCode === "QUICK_PAY_LAST_PARAGRAPH") {
        this.setState({
          lastNote: item.answer,
        });
      }
    });
  }).catch((err) => {
    store.getState().snackbar=false;
  }) 
}


  render() {
    let { labelSubTitle, lastNote, data } = this.state;

    return (
      <React.Fragment>
        <CardContent className="cardPadding">
          {labelSubTitle ? (
            <QuickPayCommonHeader
              labelSubTitle={labelSubTitle}
              baseStyle={this.props.baseStyle}
              billpay="false"
            />
          ) : (
            <Skeleton />
          )}
          {data ? (
            <QuickPayLanding
              baseStyle={this.props.baseStyle}
              lastNote={lastNote}
              data={data}
              authStyle={this.props.authStyle}
              billpay={false}
            />
          ) : (
            <Skeleton variant="text" />
          )}
        </CardContent>
      </React.Fragment>
    );
  }
}

export default QuickPay;
